/**
 * LEP Video — click/touch to play with sound
 * Play button overlay, toggle on click/touch
 */

(function () {
  'use strict';

  var wrappers = document.querySelectorAll('[data-lep-video]');

  if (!wrappers.length) return;

  wrappers.forEach(function (wrapper) {
    var video = wrapper.querySelector('.lep-video__player');
    var playBtn = wrapper.querySelector('.lep-video__play');

    if (!video) return;

    function play() {
      video.muted = false;
      video.play().then(function () {
        wrapper.classList.add('is-playing');
      }).catch(function () {
        // Fallback: if unmuted play fails (autoplay policy), try muted
        video.muted = true;
        video.play().then(function () {
          wrapper.classList.add('is-playing');
        });
      });
    }

    function pause() {
      video.pause();
      wrapper.classList.remove('is-playing');
    }

    function toggle() {
      if (video.paused) {
        play();
      } else {
        pause();
      }
    }

    // Click on play button
    if (playBtn) {
      playBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        toggle();
      });
    }

    // Click on video/wrapper area
    wrapper.addEventListener('click', toggle);

    // Sync state when video ends
    video.addEventListener('ended', function () {
      wrapper.classList.remove('is-playing');
    });
  });
})();
